import { useState } from "react";
import { ScreenContainer } from "../../components";
import { ScreenProps } from "./types";
import OrderForm from "./OrderForm";
import SuccessModal from "./SuccessModal";
import { OrderType, PaymentMethod, SHARED_ORDER_FIELDS } from "./OrderForm/types";
import { gql, useQuery } from "@apollo/client";
import { ActivityIndicator } from "react-native-paper";
import { Platform, View } from "react-native";
import config from "../../config";
import { CURRENT_MEMBER_FRAGMENT, CurrentMember } from "../fragments";
import { ProgressBar } from "react-native-paper";
import { colors } from "../../../theme";
import { useFeatureFlags } from "../../hooks/useFlagr";

interface QueryType {
  duesCycle: {
    order: OrderType;
  };
  currentMember: CurrentMember;
}

export const DUES_QUERY = gql`
  query GetDuesOrder($orderId: ID) {
    currentMember {
      ...CurrentMemberFragment
    }
    duesCycle: currentDuesCycle(orderId: $orderId) {
      id
      order {
        ${SHARED_ORDER_FIELDS}
      }
    }
  }
  ${CURRENT_MEMBER_FRAGMENT}
`;

function DuesSummaryScreen({ navigation, route }: ScreenProps<"DuesSummary">) {
  const [successfullPaymentMethod, setSuccessfulPaymentMethod] = useState<PaymentMethod>();
  const flags = useFeatureFlags();

  const { data } = useQuery<QueryType>(DUES_QUERY, {
    ...(flags["dues-order-lookup"] && { variables: { orderId: route.params?.orderId } }),
  });

  if (!data?.duesCycle?.order) {
    return (
      <View className="flex-1 bg-sky-white items-center justify-center">
        <ActivityIndicator />
      </View>
    );
  }

  return (
    <ScreenContainer testID="DuesScreen" navigationTitle="Dues Summary">
      {Platform.OS !== "web" && <ProgressBar progress={0.75} color={colors.primary.light} />}
      <OrderForm
        order={data.duesCycle.order}
        onComplete={(paymentMethod) => {
          setSuccessfulPaymentMethod(paymentMethod);
        }}
      />
      <SuccessModal
        visible={!!successfullPaymentMethod}
        paymentMethod={successfullPaymentMethod}
        email={data?.currentMember?.primaryEmail}
        onClose={() => {
          if (Platform.OS === "web") {
            window.location.assign(`https://${config.accountDomain}`);
          } else {
            navigation.getParent()?.goBack();
          }
        }}
      />
    </ScreenContainer>
  );
}

export default DuesSummaryScreen;
